import "./gallery.scss";
import  { useState } from "react";
import { Heading } from "../../components/Reusable/resuable";
import { useAppSelector } from "../../Redux/hook";
const SetGallery = ({heading,images}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
    const lightMode = useAppSelector((state) => state.mode.lightMode);

  const openImageViewer = (index) => {
    setCurrentImageIndex(index);
  };
  const closeImageViewer = () => {
    setCurrentImageIndex(null);
  };

  return (
    <div className="gimages">
      <Heading heading={heading} lightMode={lightMode}/>
      <div className="image-gallery">
        {images.map((src, index) => (
          <img
            key={index}
            src={src.image}
            alt={`Image ${index + 1}`}
            className="thumbnail"
            onClick={() => openImageViewer(index)}
          />
        ))}
      </div>

      {currentImageIndex !== null && (
        <ImageViewer
          images={images}
          currentIndex={currentImageIndex}
          onClose={closeImageViewer}
          setCurrentIndex={setCurrentImageIndex}
        />
      )}
    </div>
  );
};

const ImageViewer = ({ images, currentIndex, onClose, setCurrentIndex }) => {
  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : images.length - 1
    );
  };

  const nextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < images.length - 1 ? prevIndex + 1 : 0
    );
  };

  return (
    <div className="image-viewer">
      <div className="viewer-overlay" onClick={onClose}></div>
      <div className="viewer-content">
        {/* <button className="viewer-close" onClick={onClose}>
          &times;
        </button> */}
        <button className="viewer-prev" onClick={prevImage}>
          &#8249;
        </button>
        <img src={images[currentIndex].image} alt={`Image ${currentIndex + 1}`} />
        <button className="viewer-next" onClick={nextImage}>
          &#8250;
        </button>
      </div>
    </div>
  );
};

export {SetGallery,ImageViewer};